"use client"

import { create } from "zustand"
import { VoiceboxProps } from "@/schemas"

const defaultOnError = (error: string) => console.error("[Meridial] ", error)

interface MeridialState {
  open: boolean
  setOpen: (open: boolean) => void
  props: VoiceboxProps | undefined
  setProps: (
    updater: (prev: VoiceboxProps | undefined) => VoiceboxProps
  ) => void
  reportError: (error: string) => void
}

export const useMeridialStore = create<MeridialState>((set, get) => ({
  open: false,
  setOpen: (open) => set({ open }),
  props: undefined,
  setProps: (updater) => set((state) => ({ props: updater(state.props) })),
  reportError: (error) => {
    const onError = get().props?.onError ?? defaultOnError
    onError(error)
  },
}))
